export default __webpack_public_path__ + "static/media/crash-error.3b356196.svg";